// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".merge-request-overview-layout{min-height:100px;position:relative;display:flex;flex-direction:column;gap:24px}.merge-request-overview-layout .merge-request-overview-layout__content{min-height:200px;position:relative}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
